var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.0376C30 6.73684 23.28 0 15 0C6.72 0 0 6.73684 0 15.0376C0 22.3158 5.16 28.3759 12 29.7744V19.5489H9V15.0376H12V11.2782C12 8.37594 14.355 6.01504 17.25 6.01504H21V10.5263H18C17.175 10.5263 16.5 11.203 16.5 12.0301V15.0376H21V19.5489H16.5V30C24.075 29.2481 30 22.8421 30 15.0376Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.e7aa735289343f04c91059fd66fd300a.svg";
export { ForwardRef as ReactComponent };